<template>
  <div>
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{ label }}</label>

    <div v-for="(group, groupIndex) in modelValue" class="border border-gray-200 mb-2 p-2" :key="groupIndex">
      <slot :inputs="inputs" :groupIndex="groupIndex"></slot>
      <button v-if="groupIndex > 0" @click="removeGroup(groupIndex)">Odebrat skupinu</button>
    </div>
    <button v-if="multiple" @click="addGroup">Přidat skupinu</button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import type {FormGroup, FormInput} from "@haxo-cz/tsoa-modules";


export default defineComponent({
  name: 'FormGroupModuleForm',
  props: {
    label: {
      type: String,
      required: true,
    },
    inputs: {
      type: Array as PropType<FormInput[]>, // Schéma vstupů pro skupinu
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false, // Předpokládáme, že pokud není uvedeno, multiple je false
    },
    modelValue: {
      type: Array as PropType<Record<string, any>[]>,
      required: true,
    },

  },
  emits: ['update:modelValue'],
  methods: {
    addGroup() {
      const newGroup = this.inputs.reduce((acc, input) => {
        acc[input.name] = input.default || '';
        return acc;
      }, {} as Record<string, any>);
      this.$emit('update:modelValue', [...this.modelValue, newGroup]);
    },
    removeGroup(index: number) {
      const updatedGroups = [...this.modelValue];
      updatedGroups.splice(index, 1);
      this.$emit('update:modelValue', updatedGroups);
    },
  },
  mounted() {
    console.log(this.inputs);
  }
});
</script>
